import { render } from "./AnimationPage.vue?vue&type=template&id=e8a09384&ts=true"
import script from "./AnimationPage.vue?vue&type=script&lang=ts"
export * from "./AnimationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__